<template>
  <div class="courses__container">
    <course-tile
        :course="course"
        v-for="course in courses"
        v-bind:key="course.uniqueCourseId"
    />
    <div v-if="!courses.length">
      <p>{{ $t('course.noData') }}</p>
    </div>
  </div>
</template>

<script>
  import CourseTile from "@/components/course/CourseTileDetail";

    export default {
      name: "MoodleIcons",
      components: {CourseTile},
      props: {
          courses: {type:Array, required:true}
      },
    }
</script>

<style scoped lang="scss">
.courses__container {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
